import { ReactNode } from 'react';
import { isBagelLead } from '../utils';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { Box, Text, Button } from '@mantine/core';

interface BagelLeadProtectedRouteProps {
  children: ReactNode;
}

/**
 * Protected route that only allows Bagel leads (itai@getbagel.com, meir@getbagel.com)
 * Use for sensitive admin operations restricted to core team
 */
export const BagelLeadProtectedRoute = ({ children }: BagelLeadProtectedRouteProps) => {
  const user = useCurrentUser();
  const hasAccess = isBagelLead(user);

  if (!hasAccess) {
    return (
      <Box p="xl" ta="center">
        <Text size="xl" fw={600} mb="md">Access Denied</Text>
        <Text color="dimmed" mb="lg">
          You don't have permission to access this page. This page is restricted to Bagel leads only.
        </Text>
        <Button onClick={() => window.history.back()}>
          Go Back
        </Button>
      </Box>
    );
  }
  
  return <>{children}</>;
};
